import TableRowItem from './TableRowItem'

export default TableRowItem
